export const TABS_TAG_NAME = "tabs" as const;

export const TABS_CONTENT_TAG_NAME = "tabs-content" as const;

export const TABS_ACTIONS_TAG_NAME = "tabs-actions" as const;

export const TABS_LIST_TAG_NAME = "tabs-list" as const;

export const TABS_TAB_TAG_NAME = "tabs-tab" as const;

export const TABS_PANEL_TAG_NAME = "tabs-panel" as const;

export const TABS_VARIANTS = ["default", "underline", "segmented"] as const;
